import { getSessionAuthentication } from '../common/Api';

const rms2BasePath = process.env.RMS2_BASE_PATH ?? '';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface MainGroup {
    id: number;
    mainGroupCode: string;
    mainGroupDescription: string;
}

export interface Intrastat {
    id: number;
    code: string;
    internalDescription: string;
}

export interface SubCategory {
    id: number;
    subCategoryCode: string;
    subCategoryName: string;
    mainGroups: MainGroup[];
    intrastats: Intrastat[];
}

export async function getSubCategory(id: number): Promise<SubCategory> {
    return rms2Fetch<SubCategory>(`subcategories/${id}`);
}

export async function saveSubCategory(sc: SubCategory): Promise<SubCategory> {
    return rms2Fetch<SubCategory>('subcategories', {
        method: 'POST',
        body: JSON.stringify({
            id: sc.id,
            subCategoryCode: sc.subCategoryCode,
            subCategoryName: sc.subCategoryName,
            mainGroupIds: sc.mainGroups.map(mg => mg.id),
            intrastatIds: sc.intrastats.map(i => i.id),
        }),
    });
}

export async function getMainGroups(): Promise<MainGroup[]> {
    return rms2Fetch<{ mainGroups: MainGroup[] }>('subcategories/maingroups')
        .then(r => r.mainGroups);
}

export async function getIntrastats(): Promise<Intrastat[]> {
    return rms2Fetch<{ intrastats: Intrastat[] }>('subcategories/intrastats')
        .then(r => r.intrastats);
}
